import { useUserProfileStore } from "@/stores/userProfileStore";

const userProfileStore = useUserProfileStore();
export default function hasPermission(name: string) {
    return userProfileStore.hasPermission(name);
}